// extracted by mini-css-extract-plugin
export default {"Schools":"Schools_Schools__zPP9p","Schools__schools":"Schools_Schools__schools__PzKXB","Schools__school":"Schools_Schools__school__f9BcN"};